import { WhitelistAction } from '../global';

export const NA_ANSWER = 'NA_ANSWER';
export const NA_IN_PROGRESS = 'NA_IN_PROGRESS';
export const NA_STARTED = 'NA_STARTED';
export const NA_SUBMIT = 'NA_SUBMIT';
export const NA_CHECKBOX = 'NA_CHECKBOX';
export const NA_COMPLETED = 'NA_COMPLETED';

export interface NaPayload extends WhitelistAction {
  page: number;
  questionKey: string;
  questionAns: boolean;
  paxId: number;
}

export interface NAAction {
  type: string;
  payload: NaPayload;
}

export interface NACheckboxUpdate {
  paxId: number;
  uniqueKey?: string;
  value: boolean;
}

export interface PaxNAState {
  questions?: Record<string, string>;
  page?: number;
  paxId?: number;
}

export interface NAInProgress extends WhitelistAction {
  paxId?: number;
  planClass?: string;
  NACompletedAction?: boolean;
}

export interface NAInProgressAction {
  type: string;
  payload: NAInProgress;
}
export interface NACompletedAction {
  type: string;
  payload: boolean;
}

export interface NAState {
  [paxId: number]: PaxNAState[];
  naStarted?: boolean;
  inProgressNA: NAInProgress;
  isNACompleted?: boolean;
}

export interface NASubmitAction {
  type: string;
  payload?: NASubmit;
}
export interface NASubmit {
  paxId: number;
  paxNa: Record<string, string | number>;
  paxCount: number;
}

export const NAQuestionCategories = ['insuranceSameAsPrimary', 'coverageSameAsPrimary', 'existingPolicySameAsPrimary'];

export const NAQuestionsPerCategory = {
  [NAQuestionCategories[0]]: ['singleCoupleFamily', 'tripAverageLength', 'tripYearly', 'modeOfTransportation'],
  [NAQuestionCategories[1]]: [
    'baggageType',
    'flightAndTravelAccident',
    'medicalHealthInsurance',
    'nonRefundableTripCost'
  ],
  [NAQuestionCategories[2]]: ['creditCard', 'employeeBenefits', 'individualBenefits']
};

export const NAQuestionsNumeric = ['tripAverageLength', 'tripYearly'];
